import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as firebase from 'firebase';
import { AlertService } from '../../../_services/alert.service';
import { v4 as uuidv4 } from 'uuid';
import * as _ from 'underscore';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: 'app-train-bus-activity',
  templateUrl: './train-bus-activity.component.html',
  styleUrls: ['./train-bus-activity.component.css']
})
export class TrainBusActivityComponent implements OnInit {

  modalRef: any;
  iconTab: FormGroup;
  meals = ['Yes', 'No'];
  members = ['Walter White', 'Jessy Pinkman', 'Heisenberg', 'Skylar White', 'Saul Goodman']
  modes = ['Bus', 'Train']
  mealTypes = ['Personal', 'Client', 'Team']
  mealSession = ['Breakfast', 'Lunch', 'Dinner', 'Others']

  private activityList: Array<any> = [];
  tagList = [];
  isLoading: any = false;
  isUploading: any = false;
  selectedItems = [];
  snapList: any = [];
  diffList = [];
  dropdownSettings = {};
  keyIndex: any = -1;
  minDate: any;
  maxDate: any;
  startDate: any;
  currMinDate: any;
  currMaxDate: any;
  selectedMode: any;
  addedBy: any;
  verifyFields = [
    {
      "key": "modes",
      "value": "modes"
    },
    {
      "key": "meetingStartDate",
      "value": "TrainStartDate",
      "isDate": true
    },
    {
      "key": "meetingEndDate",
      "value": "TrainEndDate",
      "isDate": true
    },
    {
      "key": "prefProvider",
      "value": "PrefProvider"
    },
    {
      "key": "trainStartTime",
      "value": "TrainStartTime"
    },
    {
      "key": "prefPointDep",
      "value": "PrefPointDep"
    },
    {
      "key": "trainEndTime",
      "value": "TrainEndTime"
    },
    {
      "key": "prefPointArr",
      "value": "PrefPointArr"
    },
    {
      "key": "mealsTrain",
      "value": "MealsTrain"
    },
    {
      "key": "tagMembersTrain",
      "value": "TagMembersTrain"
    },
    {
      "key": "otherInfoTrain",
      "value": "OtherInfoTrain"
    },
    {
      "key": "transNumberTrain",
      "value": "TransNumberTrain"
    },
    {
      "key": "merchNameTrain",
      "value": "MerchNameTrain"
    },
    {
      "key": "travelClassTrain",
      "value": "TravelClassTrain"
    }
  ]

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService
  ) {
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth(),
      day: current.getDate(),
    };
  }

  @Input() data: any;
  @Input() travellers: any;
  @Input() createdBy: any;
  @Input() code: any;
  @Input() isReadOnly: any;
  @Input() isDisabled: any;
  @Input() isActivityEdit: any;
  @Output() flightData: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    this.iconTab = this.formBuilder.group({
      activityDetails: [[]],
      //  Train/Bus Activity
      modes: ['', Validators.required],
      meetingStartDate: ['', Validators.required],
      meetingEndDate: ['', Validators.required],
      meetingStart: ['', Validators.required],
      meetingEnd: ['', Validators.required],
      trainStartTime: ['', Validators.required],
      trainEndTime: ['', Validators.required],
      prefProvider: ['', Validators.required],
      prefTime: ['', Validators.required],
      prefPointDep: ['', Validators.required],
      mealsTrain: ['', Validators.required],
      prefPointArr: ['', Validators.required],
      tagMembersTrain: ['', Validators.required],
      otherInfoTrain: ['', Validators.required],
      transNumberTrain: ['', Validators.required],
      merchNameTrain: ['', Validators.required],
      travelClassTrain: ['', Validators.required],
      createdBy: ['', Validators.required],
    })

    this.tagList = this.travellers;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.iconTab.patchValue(this.data);
    this.addedBy = this.data ? this.data.createdBy : this.createdBy;
    this.createdBy = this.data ? this.data.createdBy : this.createdBy + " - " + this.code;
    this.snapList = this.data ? this.data.snapList : '' || [];
    this.selectedMode = this.data ? this.data.category : '';
    this.selectedItems = this.data ? this.data.tagMembersTrain : '' || [];
    this.diffList = this.data && this.data.activityDiffList || [];
    console.log('data@@', this.data, 'diffList --', this.diffList)
  }

  // train/bus activity
  trainActivity() {
    // this.isLoading = true
    this.activityList.push({
      category: "Train",
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      meetingStart: this.iconTab.value.meetingStart,
      meetingEnd: this.iconTab.value.meetingEnd,
      trainStartTime: this.iconTab.value.trainStartTime,
      trainEndTime: this.iconTab.value.trainEndTime,
      mode: this.iconTab.value.mode,
      prefProvider: this.iconTab.value.prefProvider,
      prefTime: this.iconTab.value.prefTime,
      prefPointDep: this.iconTab.value.prefPointDep,
      mealsTrain: this.iconTab.value.mealsTrain,
      prefPointArr: this.iconTab.value.prefPointArr,
      tagMembersTrain: this.iconTab.value.tagMembersTrain,
      otherInfoTrain: this.iconTab.value.otherInfoTrain,
      transNumberTrain: this.iconTab.value.transNumberTrain,
      merchNameTrain: this.iconTab.value.merchNameTrain,
      travelClassTrain: this.iconTab.value.travelClassTrain,
    })
    this.iconTab.patchValue({
      activityDetails: this.activityList,
      category: "Train",
      meetingStartDate: '',
      meetingEndDate: '',
      meetingStart: '',
      meetingEnd: '',
      trainStartTime: '',
      trainEndTime: '',
      mode: '',
      prefProvider: '',
      prefTime: '',
      prefPointDep: '',
      mealsTrain: '',
      prefPointArr: '',
      tagMembersTrain: '',
      otherInfoTrain: '',
      transNumberTrain: '',
      merchNameTrain: '',
      travelClassTrain: '',
    })
  }

  editTrainActivity(index, content) {
    this.modalRef = this.modalService.open(content, { windowClass: 'animated fadeInDown', size: 'xl' });
    this.keyIndex = index;
    this.iconTab.patchValue({
      mode: this.activityList[index].mode,
      meetingStartDate: this.activityList[index].meetingStartDate,
      meetingEndDate: this.activityList[index].meetingEndDate,
      meetingStart: this.activityList[index].meetingStart,
      meetingEnd: this.activityList[index].meetingEnd,
      trainStartTime: this.activityList[index].trainStartTime,
      trainEndTime: this.activityList[index].trainEndTime,
      prefProvider: this.activityList[index].prefProvider,
      prefTime: this.activityList[index].prefTime,
      prefPointDep: this.activityList[index].prefPointDep,
      mealsTrain: this.activityList[index].mealsTrain,
      prefPointArr: this.activityList[index].prefPointArr,
      tagMembersTrain: this.activityList[index].tagMembersTrain,
      otherInfoTrain: this.activityList[index].otherInfoTrain,
      transNumberTrain: this.activityList[index].transNumberTrain,
      merchNameTrain: this.activityList[index].merchNameTrain,
      travelClassTrain: this.activityList[index].travelClassTrain,
    });
    this.selectedItems = this.activityList[index].tagMembersTrain
  }

  displayMembers(allMembers: any) {
    // console.log(allMembers);
    allMembers = allMembers.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ',  ');
    return allMembers;
  }

  upDateTrainActivity() {
    this.activityList[this.keyIndex] = {
      category: 'Train',
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      meetingStart: this.iconTab.value.meetingStart,
      meetingEnd: this.iconTab.value.meetingEnd,
      trainStartTime: this.iconTab.value.trainStartTime,
      trainEndTime: this.iconTab.value.trainEndTime,
      mode: this.iconTab.value.mode,
      prefProvider: this.iconTab.value.prefProvider,
      prefTime: this.iconTab.value.prefTime,
      prefPointDep: this.iconTab.value.prefPointDep,
      mealsTrain: this.iconTab.value.mealsTrain,
      prefPointArr: this.iconTab.value.prefPointArr,
      tagMembersTrain: this.iconTab.value.tagMembersTrain,
      otherInfoTrain: this.iconTab.value.otherInfoTrain,
      transNumberTrain: this.iconTab.value.transNumberTrain,
      merchNameTrain: this.iconTab.value.merchNameTrain,
      travelClassTrain: this.iconTab.value.travelClassTrain,
    };
    this.iconTab.patchValue({
      activityDetails: this.activityList,
      category: "Train",
      meetingStartDate: '',
      meetingEndDate: '',
      meetingStart: '',
      meetingEnd: '',
      trainStartTime: '',
      trainEndTime: '',
      mode: '',
      prefProvider: '',
      prefTime: '',
      prefPointDep: '',
      mealsTrain: '',
      prefPointArr: '',
      tagMembersTrain: '',
      otherInfoTrain: '',
      transNumberTrain: '',
      merchNameTrain: '',
      travelClassTrain: '',
    });
    this.keyIndex = -1;
  }

  get f() {
    return this.iconTab.controls;
  }

  getDiffItem(key: any, val: any) {
    let d = _.groupBy(this.diffList, 'key')[key]
    if (d && d.length) {
      return d[0][val]
    }
  }

  selectTrainStartDate(event) {
    console.log(event);
    this.startDate = event;
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      meetingStartDate: finalDate
    })
    this["meetingStart"] = finalDate;
  }

  selectTrainEndDate(event) {
    console.log(event);
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      meetingEndDate: finalDate
    })
    this["meetingEnd"] = finalDate;
  }

  getMinDate() {
    if (this.startDate) {
      return (this.startDate)
    } else {
      return this.minDate
    }
  }

  readableDateFormat(userDate: any) {
    if (!_.isObject(userDate)) {
      return userDate;
    } else {
      let year = userDate.year;
      let month = userDate.month <= 9 ? '0' + userDate.month : userDate.month;;
      let day = userDate.day <= 9 ? '0' + userDate.day : userDate.day;;
      let finalDate = day + "-" + month + "-" + year;
      return finalDate;
    }
  }

  addNewItem() {
    // RG
    Swal.fire({
      title: 'Are you sure,You want to Save?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        if (!this.iconTab.value.modes || !this.iconTab.value.meetingStart
          || !this.iconTab.value.trainStartTime || this.iconTab.value.tagMembersTrain.length == 0) {
          this.alertService.showError('Mandatory fields to be filled !');
          return false;
        }

        let isMatch = _.isMatch(this.data, this.iconTab.value);
        if (isMatch && this.isActivityEdit) {
          this.alertService.showError('No Changes made to amend !', 3000, 'Invalid update !')
          return false;
        }

        let activityDiffList = [];
        if (!isMatch && this.isActivityEdit) {
          let that = this;
          let old = _.clone(this.data), fresh = _.clone(this.iconTab.value);
          _.each(this.verifyFields, function(field) {
            let newVal = fresh[field.key], oldVal = old[field.key];
            if (old[field.key] != fresh[field.key]) {

              // if (field.key == 'meals' && newVal == 'No') {
              //   newVal = fresh['meals']
              // } else {
              //   newVal = fresh['meals']
              // }

              activityDiffList.push({
                key: field.key,
                name: field.value,
                oldVal: field.isDate ? that.readableDateFormat(old[field.key]) : oldVal,
                newVal: field.isDate ? that.readableDateFormat(fresh[field.key]) : newVal
              })
            }
          })
        }

        console.log('am in addNewItem ', activityDiffList, this.activityList, this.iconTab.value);
        this.flightData.emit({ ...this.iconTab.value, activityDiffList: activityDiffList, key: this.code, snapList: this.snapList, category: this.selectedMode, uniqueId: uuidv4(), addedBy: this.addedBy });
        this.closeModal()
      }
    })
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  chooseFile() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Upload Confirmation Doc?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        document.getElementById("avatar").click();
      }
    })
  }

  upload() {
    // Create a root reference
    let storageRef = firebase.storage().ref();
    this.isUploading = true;
    let that = this;

    for (let selectedFile of [(<HTMLInputElement>document.getElementById('avatar')).files[0]]) {
      // let path = '/BILLS/' + Date.now() + `${selectedFile.name}`;
      let path = '/BILLS/' + Date.now() + '_' + `${selectedFile.name}`;
      let iRef = storageRef.child(path);
      iRef.put(selectedFile).then((snapshot) => {
        snapshot.ref.getDownloadURL()
          .then((url) => {
            let images = that.snapList || [];
            images.push(url);
            that.snapList = images;
            this.isUploading = false;
          })
      });
    }
  }

  removeImage(index: any) {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Remove?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.snapList.splice(index, 1);
      }
    })
  }

  getFileName(url: any) {
    let data = '';
    if (url.split('_')[1]) {
      data = url.split('_')[1].split('?');
      data = data[0] ? decodeURI(data[0]) : '';
      return data;
    } else {
      return data;
    }
  }

}
